import { object, string } from 'yup';
import { confirmPasswordSchema, passwordDetailedSchema } from '@/shared/lib/validation/password';

export const step2Schema = object({
  nickname: string()
    .required('Обязательное поле')
    .max(16, 'Максимальная длина 16 символов')
    .matches(/^[a-zA-Zа-яА-ЯёЁ0-9-]+$/, 'Может содержать только кириллические, латинские символы, цифры и символ тире'),
  password: passwordDetailedSchema().required('Обязательное поле'),
  confirmPassword: confirmPasswordSchema('password', 'Пароли не совпадают').required('Обязательное поле'),
});
